import {Button} from "../Button/Button"

interface VideoControlButtonProps {
    isPlaying: boolean
    onClick: () => void
    className?: string
    disabled?: boolean
}

export const VideoControlButton = ({
    isPlaying,
    onClick,
    className,
    disabled = false,
}: VideoControlButtonProps) => (
    <Button onClick={onClick} disabled={disabled} className={className}>
        {isPlaying ? "\u23F8" : "▷"}
    </Button>
)
